import { render, staticRenderFns } from "./VerClienteProveedorModal.vue?vue&type=template&id=526f2c2a&"
import script from "./VerClienteProveedorModal.vue?vue&type=script&lang=ts&"
export * from "./VerClienteProveedorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports